import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
function useSpacingValue() {
  const { cssVarPrefix } = useTheme();
  const [spacingValue, setSpacingValue] = useState(8);
  useEffect(() => {
    const computedStyle = getComputedStyle(document.documentElement);
    const spacing = computedStyle.getPropertyValue(`--${cssVarPrefix}-spacing`);
    const spacingInPixels = Number.parseInt(spacing, 10);
    setSpacingValue(spacingInPixels);
  }, [cssVarPrefix]);
  return spacingValue;
}
export {
  useSpacingValue
};
//# sourceMappingURL=useSpacingValue.js.map
